// extracted by mini-css-extract-plugin
export default {"avatar":"_avatar_avatar__8QD5G","iniciais":"_avatar_iniciais__j4wwe"};